export const columns = function () {
    return [
        {
            prop: 'insBillId',
            label: '服务单流水号',
            fixed: 'left',
            minWidth: 150
        },
        {
            prop: 'carNo',
            label: '车牌号',
            minWidth: 100
        },
        {
            prop: 'status',
            label: '状态',
            minWidth: 100,
            render: ({ status }) => {
                return (this.$emun.apprStatus.find(item => item.value === status)).label || '-'
            }
        },
        {
            prop: 'beginTime',
            label: '服务起期',
            sortable: true,
            minWidth: 200
        },
        {
            prop: 'endTime',
            label: '服务止期',
            sortable: true,
            minWidth: 200
        },
        {
            prop: 'orgName',
            label: '出单机构',
            minWidth: 100
        },
        {
            prop: 'saleName',
            label: '业务员',
            minWidth: 100
        },
        {
            prop: 'c_contractFee',
            label: '应收差额（元）',
            sortable: true,
            minWidth: 150
        },
        {
            prop: 'c_netFee',
            label: '净费差额（元）',
            sortable: true,
            minWidth: 150
        },
        {
            prop: 'c_cashFee',
            label: '现金折扣差额（元）',
            sortable: true,
            minWidth: 200
        },
        {
            prop: 'auditName',
            label: '审核人',
            minWidth: 100
        },
        {
            prop: 'auditTime',
            label: '审核时间',
            sortable: true,
            minWidth: 200
        },
        {
            prop: 'fauditName',
            label: '财务审核',
            minWidth: 100
        },
        {
            prop: 'fauditTime',
            label: '财务审核时间',
            sortable: true,
            minWidth: 150
        },
        {
            prop: 'real_pay_time',
            label: '实际支付时间',
            sortable: true,
            minWidth: 200
        },
        {
            prop: 'CreatorName',
            label: '制单人',
            minWidth: 100
        },
        {
            prop: 'create_time',
            label: '创建时间',
            sortable: true,
            minWidth: 200
        },
        {
            prop: 'pd_remark',
            label: '备注',
            minWidth: 200
        },
        {
            prop: 'effectTime',
            label: '生效时间',
            sortable: true,
            minWidth: 200
        },
        {
            prop: 'handle',
            label: '操作',
            minWidth: 200,
            fixed: 'right'
        }
    ]
}

export default {}